import {Component} from '@angular/core';

@Component({
  selector: 'cui-sidenav-info',
  template: '<ng-content></ng-content>',
  styles: [
    ':host { display: block; }'
  ]
})
export class CuiSidenavInfoComponent { }



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/navigation/sidenav/sidenav-info/sidenav-info.component.ts